/* eslint-disable */
import PropTypes from "prop-types";
// import "../../../../.."
import "../../../../../styles/ComponentsStyles/Organizational/Management/Dashboard/OverviewCard.style.css";
// import "../../../../../styles/PagesComponents/Organizational/Management/Dashboard/OverviewCard.style.css"
// import "../../../../../styles/Pages/Organizational/Management"

const DashboardOverviewCard = ({
  icon,
  title,
  presentCount = "",
  totalCount = "",
  cardType,
  bgColor,
}) => {
  return cardType.toLowerCase() === "regular" ? (
    <div className="regularBlocks">
      <div className="iconDiv" style={{ backgroundColor: bgColor }}>
        {icon && <img className="icon" src={icon} />}
      </div>
      <div className="text-content">
        <h3 className="title">{title}</h3>
        {presentCount !== "" && totalCount !== "" ? (
          <p className="value">
            {presentCount}/{totalCount}
          </p>
        ) : (
          <p className="value">{presentCount}</p>
        )}
      </div>
    </div>
  ) : (
    <div className="smallBlocks" style={{ backgroundColor: bgColor }}>
      {/* {icon && <img className="icon" src={icon} />} */}
      <div className="text-content">
        <h3 className="title" style={{ color: "white" }}>
          {title}
        </h3>
        <p className="value" style={{ color: "white" }}>
          {presentCount}/{totalCount}
        </p>
      </div>
    </div>
  );
};

export default DashboardOverviewCard;

DashboardOverviewCard.propTypes = {
  icon: PropTypes.element,
  title: PropTypes.string,
  presentCount: PropTypes.string,
  totalCount: PropTypes.string,
  cardType: PropTypes.string,
  bgColor: PropTypes.string,
};
